import EditGroupModal from './containers/EditGroupContainer'

export default EditGroupModal
